(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-oc-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-oc-slide]')];
      const dots = [...hero.querySelectorAll('[data-oc-dot]')];
      let index = 0, start;
      const select = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('is-active', i === index); });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        const status = hero.querySelector('[data-oc-slide-status]');
        if (status) status.textContent = `Ambiente ${index + 1} de ${slides.length}`;
      };
      hero.querySelectorAll('[data-oc-controls]').forEach(el => el.hidden = false);
      hero.querySelector('[data-oc-prev]')?.addEventListener('click', () => select(index - 1));
      hero.querySelector('[data-oc-next]')?.addEventListener('click', () => select(index + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => select(i)));
      hero.addEventListener('keydown', e => { if (['ArrowLeft', 'ArrowRight'].includes(e.key)) { e.preventDefault(); select(index + (e.key === 'ArrowRight' ? 1 : -1)); } });
      hero.addEventListener('pointerdown', e => { if (!e.target.closest('a,button') && e.button === 0) start = {x:e.clientX,y:e.clientY}; });
      hero.addEventListener('pointerup', e => { if (start) { const dx=e.clientX-start.x,dy=e.clientY-start.y; if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)) select(index+(dx<0?1:-1)); start=null; } });
      hero.addEventListener('pointercancel', () => start = null);
      hero.addEventListener('shopify:block:select', e => { const target=slides.findIndex(s=>s.contains(e.target)); if(target>=0)select(target); });
    });
    root.querySelectorAll('[data-oc-inspiration]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('[data-oc-filters]');
      if (!form) return;
      const cards = [...section.querySelectorAll('[data-oc-card]')];
      const keys = ['estancia', 'ocasion', 'estilo', 'tamano', 'presupuesto'];
      const apply = (writeUrl = true) => {
        const values = Object.fromEntries(keys.map(key => [key, form.elements.namedItem(key).value]));
        let count = 0;
        cards.forEach(card => {
          const area = +card.dataset.area, budget = +card.dataset.budget;
          const size = area <= 10 ? 'small' : area <= 20 ? 'medium' : 'large';
          const visible = ['estancia','ocasion','estilo'].every(key => !values[key] || card.dataset[key] === values[key]) && (!values.tamano || values.tamano === size) && (!values.presupuesto || (budget > 0 && budget <= +values.presupuesto));
          card.hidden = !visible; if (visible) count++;
        });
        section.querySelector('[data-oc-count]').textContent = `${count} ${count === 1 ? 'ambiente' : 'ambientes'}`;
        section.querySelector('[data-oc-empty]').hidden = count > 0;
        if (writeUrl) {
          const url = new URL(location.href);
          keys.forEach(key => values[key] ? url.searchParams.set(key, values[key]) : url.searchParams.delete(key));
          history.replaceState(null, '', url);
        }
      };
      const loadUrl = () => { const params = new URLSearchParams(location.search); keys.forEach(key => { const input=form.elements.namedItem(key), value=params.get(key)||''; input.value=[...input.options].some(o=>o.value===value)?value:''; }); apply(false); };
      form.addEventListener('submit', e => e.preventDefault());
      form.addEventListener('change', () => apply());
      form.addEventListener('reset', e => { e.preventDefault(); keys.forEach(key => { form.elements.namedItem(key).value = ''; }); apply(); });
      window.addEventListener('popstate', loadUrl);
      loadUrl();
    });
    root.querySelectorAll('.oc-hotspot').forEach(spot => {
      if (spot.dataset.ready) return;
      spot.dataset.ready = 'true';
      const close = spot.querySelector('[data-oc-close]');
      if(close){close.hidden=false;close.addEventListener('click', () => {spot.open=false;spot.querySelector('summary').focus();});}
      spot.addEventListener('toggle', () => {if(spot.open) document.querySelectorAll('.oc-hotspot[open]').forEach(other=>{if(other!==spot)other.open=false;});});
      spot.addEventListener('keydown', e => { if(e.key==='Escape'){spot.open=false;spot.querySelector('summary').focus();} });
    });
    root.querySelectorAll('.oc-nav details').forEach(menu=>{if(menu.dataset.ready)return;menu.dataset.ready='true';menu.addEventListener('toggle',()=>{if(menu.open)document.querySelectorAll('.oc-nav details[open]').forEach(other=>{if(other!==menu)other.open=false;});});menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});});
  };
  document.addEventListener('click',e=>{document.querySelectorAll('.oc-hotspot[open],.oc-nav details[open]').forEach(el=>{if(!el.contains(e.target))el.open=false;});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
